module.exports = __webpack_public_path__ + "static/media/account-circle-material.07db67d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/images/account-circle-material.svg
// module id = 1238
// module chunks = 0